import {
  type Diwali2026Variant,
  getDiwali2026SlideKey,
  getDiwali2026Variant,
  resolveDiwali2026Variant,
} from '~/features/promotions/utils/get-diwali-2026-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const DIWALI_2026_CAMPAIGN_ID = 'diwali-2026';

export const diwali2026CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<Diwali2026Variant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: DIWALI_2026_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getDiwali2026SlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getDiwali2026Variant(forcedPromotionId) != null || getDiwali2026Variant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getDiwali2026Variant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveDiwali2026Variant(forcedPromotionId, promotionId),
};
